import { render, staticRenderFns } from "./ProfessorsGrid.vue?vue&type=template&id=23ceff25"
import script from "./ProfessorsGrid.vue?vue&type=script&lang=js"
export * from "./ProfessorsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports